import { SET_NAV_TAB, SET_SIDEBAR_MOBILE_OPEN, FETCH_DATA_ERROR, CLEAR_GLOBAL_ERROR_MSG } from '../actionTypes';
import { ACTIVE_HOME_TAB } from '../constants';
import { ERROR_CODES } from '../../constants';

const initialState = {
    currentNavTab: ACTIVE_HOME_TAB,
    isSidebarMobileOpen: false,
    loading: false,
    errorMsg: '',
};

export default function(state = initialState, action) {
    switch(action.type) {
        case SET_NAV_TAB: {
            return {
                ...state,
                currentNavTab: action.payload,
            }
        }

        case SET_SIDEBAR_MOBILE_OPEN: {
            return {
                ...state,
                isSidebarMobileOpen: action.payload,
            }
        }

        case FETCH_DATA_ERROR: {
            return {
                ...state,
                errorMsg: ERROR_CODES[action.payload?.error?.code]
            }
        }

        case CLEAR_GLOBAL_ERROR_MSG:
            return {
                ...state,
                errorMsg: ""
            }

        default:
            return state
    }
}